import * as React from 'react';
import styled, { css } from 'styled-components';
import { AccordionItemPanel as A11yAccordionItemPanel } from 'react-accessible-accordion';
import { Link } from '../../Action';
import { get } from '../../tools/utils';
import { useAccordion } from '../AccordionContext';
import { AccordionItemContext } from '../AccordionItemContext';
const NavigationLinkListContainer = styled.nav `
  background-color: #480348;
`;
const NavigationUL = styled.ul `
  margin: 0;
  padding: 0;
`;
const NavigationLinkContainer = styled.li `
  border-bottom: 1px solid ${get.colors('slate-3')};
  height: 32px;

  ${({ theme: { media } }) => `
    ${media.down('md')} {
      height: 45px;
  `}
`;
const NavigationLink = styled(Link) `
  color: ${get.colors('white')};
  /** Padding left of caret, padding right of caret, width of caret */
  padding-left: calc(${get.space('md')} * 2 + ${get.iconSize('xs')});
  height: 100%;
  display: flex;
  align-items: flex-start;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  font-size: ${get.fontSizes('md')};

  &:hover {
    color: ${get.colors('white')};
  }

  ${({ $backgroundColor, theme: { colors } }) => {
    if (!$backgroundColor) {
        return css ``;
    }
    return css `
      background-color: ${colors[$backgroundColor]};
    `;
}}
`;
const LinearGradient = styled.div `
  height: 8px;
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.03) 0%,
    rgba(249, 249, 249, 0.03) 100%
  );
`;
const AccordionItemBackground = styled.div `
  background-color: ${({ theme: { colors } }) => colors.white};
`;
const InnerAccordionItemBox = styled.div `
  padding: ${get.space('md')};
  padding-top: ${get.space('xxs')};
`;
const AccordionItemBox = ({ variant, children, }) => {
    if (variant === 'CONTAINER') {
        return (React.createElement(AccordionItemBackground, null,
            React.createElement(LinearGradient, null),
            React.createElement(InnerAccordionItemBox, null, children)));
    }
    return React.createElement(React.Fragment, null, children);
};
const StyledA11yAccordionItemPanel = styled(A11yAccordionItemPanel) `
  border: none;
  ${({ $variant, theme: { colors, space, iconSize }, }) => {
    switch ($variant) {
        case 'CONTAINER':
            return css `
          border-bottom: 1px solid ${colors['slate-2']};
        `;
        case 'STEPPED_PROCESS':
            return css `
          /* The 3px offset aligns the edge with the caret in the header */
          padding: 0 ${space.md} ${space.lg} calc(${space.md} - 3px);
          background-color: ${colors.white};
        `;
        case 'CONTAINERLESS':
            return css `
          background-color: inherit;
          padding-left: calc(${space.md} + ${iconSize.xl});
        `;
        case 'NAVIGATION':
            return css `
          box-shadow: inset 0 4px 0 0 rgba(0, 0, 0, 0.1);
          background-color: inherit;
        `;
        default:
            return css ``;
    }
}}
  &:focus {
    outline: none;
  }
`;
const AccordionItemPanel = ({ content, isExpanded, closePanel, uuid, }) => {
    const { variant } = content;
    const { panelsToOpenOnMount } = useAccordion();
    const [isPreExpanding, setIsPreExpanding] = React.useState(uuid !== undefined &&
        Array.isArray(panelsToOpenOnMount) &&
        // Casting fixes a weird issue where `contains` has a first param of type never
        panelsToOpenOnMount.includes(uuid));
    const handleFocus = React.useCallback((node) => {
        if (node && isExpanded && !isPreExpanding) {
            node.focus();
        }
        if (isPreExpanding) {
            setIsPreExpanding(false);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isExpanded]);
    switch (content.variant) {
        case 'CONTAINER':
        case 'CONTAINERLESS':
        case 'STEPPED_PROCESS':
            return (React.createElement(StyledA11yAccordionItemPanel, { "$variant": variant },
                React.createElement(AccordionItemBox, { variant: variant },
                    React.createElement(AccordionItemContext.Provider, { value: { handleFocus, isExpanded, closePanel } }, content.payload))));
        case 'NAVIGATION':
            return (React.createElement(StyledA11yAccordionItemPanel, { "$variant": variant },
                React.createElement(AccordionItemBox, { variant: variant },
                    React.createElement(NavigationLinkListContainer, null,
                        React.createElement(NavigationUL, null, content.routes.map(({ title, url, color }, index) => {
                            const key = `${title}-${index}`;
                            return (React.createElement(NavigationLinkContainer, { key: key },
                                React.createElement(NavigationLink, Object.assign({ id: "accordion-navigation-link", text: title, href: url, "$backgroundColor": color }, (index === 0 ? { ref: handleFocus } : {})))));
                        }))))));
        default:
            return (React.createElement(StyledA11yAccordionItemPanel, { "$variant": variant },
                React.createElement(AccordionItemBox, { variant: variant })));
    }
};
export default AccordionItemPanel;
//# sourceMappingURL=AccordionItemPanel.js.map